import React, { Fragment, useState } from 'react';
import { OrganizationKpisList } from './OrganizationKpisList';
import { Box } from '@material-ui/core';

export const OrganizationKpis: React.FC<any> = (props: any) => {
	const { handleEditOrgKpisClick } = props;
	const [openCloneDialog, setOpenCloneDialog] = useState<any>({
		open: false,
		openId: 0,
	});
	const handleCloneOkr = (e: any, defaultGoalObjectiveId: number) => {
		setOpenCloneDialog({
			...openCloneDialog,
			open: !openCloneDialog.open,
			openId: defaultGoalObjectiveId,
		});
	};
	const handleCloneSubmit = async (e: React.ChangeEvent<HTMLInputElement>, cloneObj: any) => {};
	//
	return (
		<Box className='org-kpi-setting-container'>
			<OrganizationKpisList
				{...props}
				//handleCloneOkr={handleCloneOkr}
				handleEditOrgKpisClick={handleEditOrgKpisClick}
			/>
			{/* <CloneDefaultOkrDialog
				modalOpen={openCloneDialog}
				handleCloseModal={handleCloneOkr}
				handleCloneSubmit={handleCloneSubmit}
			/> */}
		</Box>
	);
};
